export const commentaryTab = {
  link: 'matchLiveBlogData',
  name: 'Commentary',
  slug: 'match-center-liveblog',
  is_active: 'true',
  id: 'matchLiveBlogDataContainer',
};
export const ScoreCardTab = {
  link: 'matchScoreCardData',
  name: 'Scorecard',
  slug: 'match-center-scorecard',
  is_active: 'true',
  donotShowUpcoming: 'true',
  id: 'matchScoreCardDataContainer',
};
export const ArticleNewsTab = {
  link: 'matchArticleData',
  name: 'News',
  slug: 'match-center-article',
  is_active: 'false',
  id: 'matchArticleDataContainer',
};
export const processBatsMan = (innings, team) => {
  let batsmanArr = [];
  if (innings && Array.isArray(innings) && innings.length > 0) {
    batsmanArr = innings.map(batsman => {
      let name = team?.Players?.[`${batsman?.Batsman}`]?.Name_Full;
      name = team?.Players?.[`${batsman?.Batsman}`]?.Iscaptain
        ? `${name} (C)`
        : name;
      name = team?.Players?.[`${batsman?.Batsman}`]?.Iskeeper
        ? `${name} (W)`
        : name;
      const resultbatsman = {
        name,
        batsman_id: batsman?.Batsman,
        striker: batsman?.Striker,
        howOut: batsman?.Howout,
        dismissal: batsman?.Dismissal,
        runs: batsman?.Runs,
        fours: batsman?.Fours,
        sixes: batsman?.Sixes,
        ballsFaced: batsman?.Balls,
        playerin_id: batsman?.Playerin_Id,
        Playerout_Id: batsman?.Playerout_Id,
        Is_substituted: batsman?.Is_substituted,
        issupersub: batsman?.Issupersub,
        strikeRate: batsman?.Strikerate,
        link: `/topic/${name ? name.toLowerCase().replace(' ', '-') : ''}`,
      };
      return resultbatsman;
    });
    return batsmanArr;
  }
  return batsmanArr;
};

export const processBowler = (innings, team) => {
  let bowlerArray = [];
  if (innings && Array.isArray(innings) && innings.length > 0) {
    bowlerArray = innings.map(bowler => {
      let name = team?.Players?.[`${bowler?.Bowler}`].Name_Full;
      name = team?.Players?.[`${bowler?.Bowler}`]?.Iscaptain
        ? `${name} (C)`
        : name;
      name = team?.Players?.[`${bowler?.Bowler}`]?.Iskeeper
        ? `${name} (W)`
        : name;
      const runstaken =
        bowler?.Runs && bowler?.Overs > 0
          ? (bowler?.Runs / bowler?.Overs).toFixed(2)
          : '';
      const resultbowler = {
        name,
        bowling: bowler?.Bowling,
        bowler_id: bowler?.Bowler,
        overs: bowler?.Overs,
        maidens: bowler?.Maidens,
        runsGiven: bowler?.Runs,
        wickets: bowler?.Wickets,
        econ: runstaken,
        wides: bowler?.Wides,
        noBalls: bowler?.Noballs,
        playerout_id: bowler?.Playerout_Id,
        playerin_id: bowler?.Playerin_Id,
        is_substituted: bowler?.Is_substituted,
        issupersub: bowler?.Issupersub,
        link: `/topic/${name ? name.toLowerCase().replace(' ', '-') : ''}`,
      };
      return resultbowler;
    });
    return bowlerArray;
  }
  return bowlerArray;
};

export const processPredictorData = (data, teamaid) => {
  let predictorRefreshData;
  if (data) {
    predictorRefreshData =
      Array.isArray(data) && data.length > 0
        ? data.sort(teama => {
            const fa = teama && teama.team_id ? teama.team_id : '';

            if (fa === teamaid) {
              return -1;
            }
            return 1;
          })
        : [];
  }
  return predictorRefreshData;
};

export const processCommentaryData = items => {
  if (items && Array.isArray(items) && items.length > 0) {
    let result = items.map(match => {
      const totalScore =
        match && match.Score && match.Score !== ''
          ? match.Score.split('/')
          : [];
      const totalRun =
        totalScore &&
        Array.isArray(totalScore) &&
        totalScore.length > 0 &&
        totalScore[0]
          ? totalScore[0]
          : '';
      const wickets =
        totalScore &&
        Array.isArray(totalScore) &&
        totalScore.length > 1 &&
        totalScore[1]
          ? totalScore[1]
          : '';
      const overNo =
        match && match.Over && match.Over !== '' ? match.Over.split('.') : [];
      const timestamp =
        match && match.Timestamp && new Date(match.Timestamp)
          ? new Date(match.Timestamp).getTime()
          : '';
      const matchCommentary = match?.Default_Commentary
        ? match?.Default_Commentary.concat(match?.Commentary)
        : match?.Commentary;
        let oversummary;
        if(match?.End_Over){
          oversummary = {
            runsScored:match?.This_Over,
            batsMan:{
              striker:{
                Batsmanid:match?.Batsman_Details?.Batsman,
                Runs:match?.Batsman_Details?.Runs,
                Balls:match?.Batsman_Details?.Balls,
                Fours:match?.Batsman_Details?.Fours,
                Sixes:match?.Batsman_Details?.Sixes,
                name:match?.Batsman_Name,
              },
              Nonstriker:{
                Batsmanid:match?.Non_Striker_Details?.Batsman,
                Runs:match?.Non_Striker_Details?.Runs,
                Balls:match?.Non_Striker_Details?.Balls,
                Fours:match?.Non_Striker_Details?.Fours,
                Sixes:match?.Non_Striker_Details  ?.Sixes,
                name:match?.Non_Striker_Name,
              }
            },
            bowler:{
              name:match?.Bowler_Name,
              Bowlerid:match?.Bowler_Details?.Bowler,
              Overs:match?.Bowler_Details?.Overs,
              Maidens:match?.Bowler_Details?.Maidens,
              Runs:match?.Bowler_Details?.Runs,
              Wickets:match?.Bowler_Details?.Wickets,
            }
          }
        }
      const matchItem = {
        balls: match?.Ball,
        description: 'general',
        overs:
          overNo && Array.isArray(overNo) && overNo.length > 0 && overNo[0]
            ? overNo[0]
            : '',
        runs: match?.Runs,
        scored: match?.Runs ? 1 : '',
        timestamp,
        type: 'cricket',
        wicket: match?.Detail === 'W' ? 1 : '',
        totalRuns: totalRun,
        totalWickets: wickets,
        smalldesc: matchCommentary,
        oversummary:oversummary,
      };
      return matchItem;
    });
    if (result && Array.isArray(result) && result.length > 0) {
      result = result.slice(0, 100);
    }
    return result;
  }
  return '';
};
export const processFallOfWickets = (fow, team) => {
  let fowArray = [];
  if (fow && Array.isArray(fow) && fow.length > 0) {
    fowArray = fow.map(fownode => {
      const name = team?.Players?.[`${fownode?.Batsman}`]?.Name_Full;
      const fowEle = {
        name,
        score: fownode?.Score,
        outAt: fownode?.Overs,
        position: fownode?.Wicket_No,
      };
      return fowEle;
    });
    return fowArray;
  }
  return fowArray;
};
